import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setActiveLink } from "reduxStore/slices/sidebarSlice";
import { PATH_TO_LINK } from "configurations/Constants";

export const useActiveLink = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const pathToLink = PATH_TO_LINK;
    const active = pathToLink[location.pathname];
    if (active) dispatch(setActiveLink(active));
  }, [location.pathname, dispatch]);
};
